import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getUnreadPollCount } from '../../../polls/functions';
import { getUnreadCount } from '../../functions';
import { isMobileBrowser } from "../../../base/environment/utils";
/**
 * Implements a React {@link Component} which displays a count of the number of
 * unread chat messages.
 *
 * @augments Component
 */
class ChatCounter extends Component {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { _isOpen, _count } = this.props;
        return (React.createElement("span", { className: `badge-round${!_isOpen && _count > 0 ? ' not-empty' : ''}${isMobileBrowser() ? ' is-mobile' : ''}` },
            React.createElement("span", null, !_isOpen && (_count || null))));
    }
}
/**
 * Maps (parts of) the Redux state to the associated {@code ChatCounter}'s
 * props.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {{
 *     _count: number
 * }}
 */
function _mapStateToProps(state) {
    const { isOpen } = state['features/chat'];
    return {
        _count: getUnreadCount(state) + getUnreadPollCount(state),
        _isOpen: isOpen
    };
}
export default connect(_mapStateToProps)(ChatCounter);
